const musicImg = [
  {
    title: 'London Jazz Festival',
    img: 'https://i.imgur.com/N36ITt7.jpg',
  },
  {
    title: 'Opera Holland Park',
    img: 'https://i.imgur.com/otW9mAh.jpg',
  },
  {
    title: 'Male Singing',
    img: 'https://i.imgur.com/7RpWqkF.jpg',
  },
  {
    title: 'Clifton Harrison',
    img: 'https://i.imgur.com/VnZl3GM.jpg',
  },
  {
    title: 'What`s On Stage Awards',
    img: 'https://i.imgur.com/WNZakI9.jpg',
  },
  {
    title: 'The Turbans',
    img: 'https://i.imgur.com/ougJmdQ.jpg',
  },
  {
    title: 'Feeder',
    img: 'https://i.imgur.com/w7iTOkT.jpg',
  },
  {
    title: 'Man playing saxophone',
    img: 'https://i.imgur.com/K7g7EN8.jpg',
  },
  {
    title: 'men playing the drums',
    img: 'https://i.imgur.com/dJJyy4U.jpg',
  },
  {
    title: 'man playing bass',
    img: 'https://i.imgur.com/vbPLTaz.jpg',
  },
  {
    title: 'Royal Opera',
    img: 'https://i.imgur.com/W8tOdpP.jpg',
  },
  {
    title: 'women playing violin',
    img: 'https://i.imgur.com/wasdQu2.jpg',
  },
  {
    title: 'PYJÆN',
    img: 'https://i.imgur.com/UjcRs2m.jpg',
  },
  {
    title: 'Tony Kofi',
    img: 'https://i.imgur.com/SmB8mH1.jpg',
  },
  {
    title: 'Alex Paton',
    img: 'https://i.imgur.com/HnpeYNI.jpg',
  },
  {
    title: 'Male singing',
    img: 'https://i.imgur.com/SWatFXD.jpg',
  },
  {
    title: 'Feeder',
    img: 'https://i.imgur.com/jE9OOOP.jpg',
  },
  {
    title: 'Feeder',
    img: 'https://i.imgur.com/9nNro6w.jpg',
  },
  {
    title: 'Alex Paton',
    img: 'https://i.imgur.com/QSOSMM2.jpg',
  },
  {
    title: 'Urban Flames',
    img: 'https://i.imgur.com/2jcTEp3.jpg',
  },
  {
    title: 'Garsington Opera',
    img: 'https://i.imgur.com/PFtSZXx.jpg',
  },
  {
    title: 'Male Singing',
    img: 'https://i.imgur.com/jpvlazC.jpg',
  },
  {
    title: 'PYJÆN',
    img: 'https://i.imgur.com/alCnsL6.jpg',
  },
  {
    title: 'women singing',
    img: 'https://i.imgur.com/xHmR7B8.jpg',
  },
];

export default musicImg;
